export enum WaterType {
  HOT = 'hot',
  COLD = 'cold',
  BLENDED = 'blended',
}
